module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-route",
    attrs: {
      "id": "wrapRoute"
    }
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sp-prd-fixed-menu",
    attrs: {
      "id": "menuHeader"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('ul', {}, [_c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-descr', '')
      }
    }
  }, [_vm._v("DETAILS")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-reviews', '')
      }
    }
  }, [_vm._v("COMMENTS & REVIEWS")])])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10em"
    },
    attrs: {
      "id": "content"
    }
  }, [(_vm.seller_mode) ? _c('div', {
    staticClass: "edit-switch-bar",
    staticStyle: {
      "margin-top": "8em"
    }
  }, [(_vm.seller_mode) ? _c('div', {
    staticClass: "col-md-3 col-sm-12",
    staticStyle: {
      "margin-bottom": "2em",
      "background": "rgba(247, 242, 241, 0.89)",
      "padding": "1em"
    }
  }, [(_vm.edit_mode) ? _c('span', {
    staticClass: "product-num"
  }, [_vm._v("You are in "), _c('u', [_vm._v("Editing")]), _vm._v(" mode "), _c('button', {
    staticClass: "btn btn-xs btn-edit",
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Turn Off")])]) : _c('span', {
    staticClass: "product-num"
  }, [_vm._v("You are in "), _c('u', [_vm._v("Viewing")]), _vm._v(" mode "), _c('button', {
    staticClass: "btn btn-xs btn-edit",
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Turn Off")])])]) : _vm._e(), _vm._v(" "), (_vm.seller_mode) ? _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.edit_mode) ? _c('button', {
    staticClass: "btn btn-xs",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Edit Product")]) : _c('button', {
    staticClass: "btn btn-xs",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Done Editing")])]) : _vm._e(), _vm._v(" "), (_vm.new_added) ? _c('div', [_c('p', {
    staticClass: "new-added"
  }, [_vm._v("You have added this product, you can edit details and add more pictures")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('section', {
    staticClass: "padding-top-10 padding-bottom-10",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "1em"
    }
  }, [(!_vm.edit_mode) ? _c('div', {
    staticClass: "shop-detail"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card col-md-5 padding-bottom-100"
  }, [_c('h4', {
    staticClass: "hidden-md hidden-lg"
  }, [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "images-slider img-main-frame"
  }, [(_vm.product_display_image.product_image != '' && _vm.product_display_image.product_image != 'error') ? _c('img', {
    staticClass: "img-responsive sp-prd-img",
    attrs: {
      "src": _vm.img_product_url + _vm.product_display_image.product_image,
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "img-responsive sp-prd-img",
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-row"
  }, _vm._l((_vm.product.product_images), function(img) {
    return _c('div', {
      staticClass: "img-column"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-display-image', img)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + img.product_image,
        "alt": ""
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card sp-p-main col-md-6"
  }, [_c('div', {
    staticClass: "sp-prd-intro-block"
  }, [_c('h4', {
    staticClass: "hidden-sm hidden-xs"
  }, [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny"
  }, [_vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny"
  }, [_vm._v("Category: "), _c('span', [_c('b', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.redir(_vm.product.product_business_ownername)
      }
    }
  }, [_vm._v(_vm._s(_vm.product.product_category_name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "hozontal-flat-block"
  }, [_c('p', {
    staticClass: "pull-left"
  }, [_vm._v("reviews")]), _vm._v(" "), _c('p', {
    staticClass: "pull-right"
  }, [_vm._v("@"), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.redir(_vm.product.product_business_ownername)
      }
    }
  }, [_vm._v(_vm._s(_vm.product.product_business_ownername))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sp-prd-attr-block"
  }, [_c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [(_vm.product_item.product_item_actual_price != 0) ? _c('p', {
    staticClass: "attr-intro-desc prd-price prd-discounted-price"
  }, [_c('del', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_actual_price))])]) : _c('p', {
    staticClass: "attr-intro-desc prd-price"
  }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_price))])])]), _vm._v(" "), (_vm.product_item.product_item_actual_price != 0) ? _c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_c('p', {
    staticClass: "attr-intro-desc prd-discount-price"
  }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_price))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_c('p', {
    staticClass: "attr-intro-desc"
  }, [_vm._v(_vm._s(_vm.product_item.product_item_weight) + " (Kg)")])])]), _vm._v(" "), (((_vm.product.product_set_groups != 0))) ? _c('div', {
    staticClass: "info-block col-xs-12"
  }, [_c('div', {
    staticClass: "info-left col-xs-2"
  }, [(_vm.product.product_service == 'P') ? _c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Colour: ")]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Subscriptions: ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_vm._l((_vm.product.product_item_groups), function(pg) {
    return _c('div', {
      staticClass: "prd-color-block"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item-group', pg)
        }
      }
    }, [_c('div', {
      staticClass: "box-cube col-xs-2"
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', {
      staticClass: "product-item-group"
    }, [_c('div', {
      staticClass: "product-item-group",
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    }, [((pg.product_item_group_image && (pg.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', {}, [_c('div', {
      staticClass: "product-item-group box-color-cube",
      style: ({
        background: pg.product_item_group_color
      }),
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    })]) : _vm._e()])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.data_cart_group_message) ? _c('p', {
    staticClass: "p-tiny-info",
    staticStyle: {
      "margin-top": "-1em",
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.data_cart_group_message))]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (((_vm.product_item_group.product_items) && (_vm.product_item_group.product_items.length != 0))) ? _c('div', {
    staticClass: "info-block col-xs-12"
  }, [(((_vm.product.product_set_items != 0))) ? _c('div', [_c('div', {
    staticClass: "info-left col-xs-2"
  }, [(_vm.product.product_service == 'P') ? _c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Size: ")]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Plans: ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_c('div', {
    staticClass: "prd-color-block"
  }, _vm._l((_vm.product_item_group.product_items), function(pt) {
    return _c('div', {
      staticClass: "items-list-tiny",
      staticStyle: {
        "display": "inline"
      }
    }, [_c('li', {
      staticClass: "product-item",
      attrs: {
        "id": pt.product_item_id + 'PRT'
      }
    }, [(_vm.product.product_service == 'P') ? _c('a', {
      staticClass: "box-wrap",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_vm._v(_vm._s(pt.product_item_size))]) : _vm._e()]), _vm._v(" "), _c('li', {
      staticClass: "product-item",
      attrs: {
        "id": pt.product_item_id + 'PRT'
      }
    }, [(_vm.product.product_service == 'S') ? _c('a', {
      staticClass: "box-wrap",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_vm._v(_vm._s(pt.product_item_service_tag))]) : _vm._e()])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.data_cart_item_message) ? _c('p', {
    staticClass: "p-tiny-info",
    staticStyle: {
      "margin-top": "-0.1em",
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.data_cart_item_message))]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.product_item.product_item_total_discount != 0) ? _c('div', {
    staticClass: "on-sale"
  }, [_vm._v(" \r\n                        " + _vm._s(_vm.product_item.product_item_total_discount) + "% "), _c('span', [_vm._v("OFF")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "some-info"
  }, [(!_vm.edit_mode) ? _c('div', [(_vm.is_product_in_cart) ? _c('div', {
    staticStyle: {
      "border": "dotted 1px #96c5f5",
      "padding": "5px 2px"
    }
  }, [_c('p', [_vm._v("This Item is in your cart \r\n                              "), _c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "width": "12em",
      "cursor": "pointer",
      "line-height": "1.8"
    },
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _c('div', [_c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.product_item_order_quantity),
      expression: "product_item.product_item_order_quantity"
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-width": "102px"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product_item.product_item_order_quantity)
    },
    on: {
      "change": function($event) {
        _vm.checkOrderQuantity(_vm.product_item.product_item_order_quantity)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.product_item_order_quantity = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.check_order_quantity))])])]), _vm._v(" "), (_vm.product_item.product_item_quantity > 0) ? _c('ul', {
    staticClass: "col-xs-12 row"
  }, [_c('hr'), _vm._v(" "), (_vm.data_cart_message) ? _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v(_vm._s(_vm.data_cart_message))]) : _vm._e(), _vm._v(" "), (!_vm.product_is_ready_to_cart) ? _c('div', [_c('li', {
    staticClass: "col-md-4 col-xs-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('button', {
    staticClass: "cta-btn",
    on: {
      "click": _vm.prep_set_product_is_ready_to_cart
    }
  }, [_vm._v(" Buy Now")])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-4 col-xs-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('button', {
    staticClass: "cart-btn",
    on: {
      "click": _vm.prep_set_product_is_ready_to_cart
    }
  }, [_vm._v(" Add to Cart")])])]) : _c('div', [_c('li', {
    staticClass: "col-md-4 col-xs-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('product-cta-button', {
    attrs: {
      "productMain": _vm.product,
      "productItemGroup": _vm.product_item_group,
      "productItem": _vm.product_item
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "col-md-4 col-xs-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('add-to-cart-button', {
    attrs: {
      "productMain": _vm.product,
      "productItemGroup": _vm.product_item_group,
      "productItem": _vm.product_item
    }
  })], 1)])]) : _c('ul', {
    staticClass: "col-xs-12 row"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "#ff0000"
    }
  }, [_vm._v("This Item is out of Stock")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inner-info"
  }, [_c('div', {
    staticClass: "info-blocks"
  }, [_c('div', {
    staticClass: "info-block col-xs-12",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em",
      "background": "#fcf7f3"
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "info-right-2 col-xs-8"
  }, [_c('div', {
    staticClass: "tiny-notice"
  }, [(_vm.product.product_delivery_returns != ' ') ? _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.product.product_delivery_returns) + "\r\n                                ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Please note that Returns, Shipping and Delivery are handled independently by the seller.\r\n                                  Sellpoint only provides a conducive platform for both sellers and buyers, we also recommend reliable shipping \r\n                                  partners to make transactions seamless.\r\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-blocks"
  }, [_c('div', {
    staticClass: "info-block col-md-12 col-xs-12",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em",
      "background": "#fcf7f3"
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "info-right-2 col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "prd-delivery-list",
    staticStyle: {
      "display": "none"
    }
  }, [(((_vm.product.product_delivery_options) && (_vm.product.product_delivery_options.length != 0))) ? _c('div', _vm._l((_vm.product.product_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦" + _vm._s(delivery.business_delivery_option_price) + "\r\n                                    ")])
  })) : _c('div', _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦" + _vm._s(delivery.business_delivery_option_price) + " \r\n                                      ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "prd-delivery-list"
  }, _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦\r\n                                    "), (delivery.business_products_delivery_fees.length > 0) ? _c('span', _vm._l((delivery.business_products_delivery_fees), function(fee, fdex) {
      return _c('span', [((fee.product_delivery_product == _vm.product.product_id)) ? _c('span', [_vm._v(_vm._s(fee.product_delivery_fee) + "\r\n                                        ")]) : _vm._e()])
    })) : _c('span', [_vm._v("\r\n                                      " + _vm._s(delivery.business_delivery_option_price) + "\r\n                                    ")])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('h6', [_vm._v("SHARE THIS PRODUCT")]), _vm._v(" "), _c('ul', {
    staticClass: "social_icons"
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Click the Copy button below to Copy product link, paste the link anywhere you want to share to")]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-xs linky",
    staticStyle: {
      "cursor": "pointer",
      "padding": "10px 30px"
    },
    attrs: {
      "title": "Copy Link. Paste and Share Anywhere"
    },
    on: {
      "click": function($event) {
        _vm.copyLink()
      }
    }
  }, [_vm._v("Copy Link\r\n                              ")]), _vm._v(" "), (_vm.copied) ? _c('span', {
    staticStyle: {
      "background": "rgb(240, 227, 157)"
    }
  }, [_vm._v("Copied, Paste anywhere you want to share to")]) : _vm._e()])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "shop-detail"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card col-md-5 padding-bottom-100"
  }, [_c('h6', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-weight": "bold"
    }
  }, [_vm._v("Product Pictures")]), _vm._v(" "), _c('div', {
    staticClass: "img-row"
  }, _vm._l((_vm.product.product_images), function(pt) {
    return _c('div', {
      staticClass: "img-column"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + pt.product_image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "btn pull-right",
      staticStyle: {
        "margin-top": "-3em",
        "font-size": "10px",
        "padding": "6px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteProductImage(pt.product_image_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Add new Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'products', _vm.product.product_id)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card sp-p-main col-md-6"
  }, [_c('div', [(_vm.editProductPanel) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('h6', [_vm._v("Edit Product")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Product Name\r\n                                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_vm._v("Category:- " + _vm._s(_vm.product.product_category_name) + " ")]), _vm._v(" "), (_vm.sellpoint_categories.length > 0) ? _c('li', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Select from My Shop Categories\r\n                                        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    attrs: {
      "id": "category-type-1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-1')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_1
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      key: category.business_category_id,
      attrs: {
        "disabled": _vm.category_type_1
      },
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "col-md-4"
  }, [_c('label', [(_vm.sellpoint_categories.length > 0) ? _c('span', [_c('b', [_vm._v("Or ")])]) : _vm._e(), _vm._v(" Select from Related Categories\r\n                                        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main_category),
      expression: "main_category"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.main_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getSubCategories(_vm.main_category)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      key: category.category_id,
      domProps: {
        "value": category
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.sub_categories.length != 0) ? _c('label', [_vm._v(" Select a Category\r\n                                        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_sub_category),
      expression: "product.product_sub_category"
    }],
    staticClass: "category-type-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_sub_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_2
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(category) {
    return _c('option', {
      key: category.sub_category_id,
      attrs: {
        "disabled": _vm.category_type_2
      },
      domProps: {
        "value": category.sub_category_id
      }
    }, [_vm._v(_vm._s(category.sub_category_name))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "col-md-4"
  }, [_c('label', [_c('b', [_vm._v("Or ")]), _vm._v(" Enter a specific Category\r\n                                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_listed_category),
      expression: "product.product_listed_category"
    }],
    attrs: {
      "disabled": _vm.category_type_3,
      "type": "text",
      "placeholder": "",
      "id": "category-type-3"
    },
    domProps: {
      "value": (_vm.product.product_listed_category)
    },
    on: {
      "change": function($event) {
        _vm.trackevent('category-type-3')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_listed_category = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Description\r\n                                            "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProduct
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" Cancel")])])])])]) : _c('div', [_c('button', {
    staticClass: "btn btn-xs pull-right action-btn",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('edit-product', '')
      }
    }
  }, [_vm._v("Edit Product Details")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h6', [_c('b', [_vm._v("Product Name: ")]), _vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Description: ")]), _vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Category: ")]), _c('span', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.redir(_vm.product.product_business_ownername)
      }
    }
  }, [_vm._v(_vm._s(_vm.product.product_category_name))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.product.product_item_groups.length > 0) ? _c('div', [_c('h6', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-weight": "bold"
    }
  }, [_vm._v("Different Colors, Sizes, Plans Subscriptions ..etc")]), _vm._v(" "), _c('div', {
    staticClass: "img-row"
  }, _vm._l((_vm.product.product_item_groups), function(pg) {
    return _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "border-bottom": "1px solid #e9e6e6",
        "margin-bottom": "1em"
      }
    }, [_c('p', {
      staticClass: "pull-left",
      staticStyle: {
        "font-weight": "bold",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(pg.product_item_group_name))]), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [_c('button', {
      staticClass: "btn v-tiny-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-product-item_group', pg)
        }
      }
    }, [_c('i', {
      staticClass: "icon-pencil"
    }), _vm._v(" Edit")]), _vm._v(" "), (_vm.product.product_item_groups.length > 1) ? _c('button', {
      staticClass: "btn btn-xs v-tiny-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('remove-product-item_group', pg)
        }
      }
    }, [_c('i', {
      staticClass: "icon-trash"
    }), _vm._v(" Delete")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', [(_vm.editProductItemGroupPanel && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {
      staticClass: "col-sm-12 contact_form",
      attrs: {
        "id": "editProductItem"
      }
    }, [_c('h6', [_vm._v("Edit Product Item Group")]), _vm._v(" "), _c('div', [_c('li', {
      staticClass: "col-md-12"
    }, [_c('label', [_vm._v("Name\r\n                                          "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item_group.product_item_group_name),
        expression: "product_item_group.product_item_group_name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.product_item_group.product_item_group_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item_group.product_item_group_name = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('li', [_c('div', {
      staticClass: "box-cube col-xs-2"
    }, [(_vm.product_item_group.product_item_group_is_color_image == 'IMG') ? _c('div', {}, [((_vm.product_item_group.product_item_group_image && (_vm.product_item_group.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": _vm.product_item_group.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.product_item_group.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', {
      staticClass: "col-md-12"
    }, [_c('label', [_vm._v(" Pick Colour or Pick from uploaded Images to match the colour you are adding")])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', {
      staticClass: "col-md-12"
    }, [_c('label', [_vm._v(" Pick Colour\r\n                                              "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item_group.product_item_group_color_new),
        expression: "product_item_group.product_item_group_color_new"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "4em"
      },
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": (_vm.product_item_group.product_item_group_color_new)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item_group.product_item_group_color_new = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('li', {
      staticClass: "col-md-12"
    }, [_c('label', [_vm._v(" Pick Image")]), _vm._v(" "), _c('div', {
      staticClass: "img-row"
    }, _vm._l((_vm.product.product_images), function(img, index) {
      return _c('div', {
        key: index,
        staticClass: "col-xs-1",
        staticStyle: {
          "height": "80px",
          "width": "100px"
        },
        attrs: {
          "id": "groupImage"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('set-product-item-group-image', img.product_image_id)
          }
        }
      }, [_c('img', {
        staticClass: "product-item-group-image sp-prd-img",
        attrs: {
          "id": img.product_image_id + 'PRTG',
          "src": img.product_image,
          "alt": ""
        }
      })])])
    })), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "z-index": "9"
      }
    }, [_c('div', {
      staticClass: "upload-btn-wrapper",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('button', {
      staticClass: "upload-btn"
    }, [_vm._v("Or Add new Image")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "input-file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.onFileChange($event, 'products', _vm.product.product_id)
        }
      }
    })])])]), _vm._v(" "), _c('li', {
      staticClass: "col-md-12"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn col-md-4",
      staticStyle: {
        "line-height": "1.2",
        "margin-right": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.editProductItemGroup
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn col-md-4",
      staticStyle: {
        "line-height": "1.2",
        "margin-right": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_c('i', {
      staticClass: "icon-ban"
    }), _vm._v(" Cancel")])])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.removeItemGroupPanel && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('span', {
      staticClass: "pull-left col-sm-12"
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Do you really want to remove this Item Group?")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs",
      on: {
        "click": function($event) {
          _vm.removeProductItemGroup()
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs",
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "box-cube col-xs-2"
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', {}, [((pg.product_item_group_image && (pg.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8"
    }, [_c('h5', {
      staticStyle: {
        "font-size": "10px",
        "text-transform": "capitalize"
      }
    }, [(_vm.product.product_service == 'P') ? _c('span', [_vm._v("Sizes in this Colour:")]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('span', [_vm._v("Service Packages:")]) : _vm._e()]), _vm._v(" "), _vm._l((pg.product_items), function(pt) {
      return _c('div', {
        staticClass: "items-list-tiny",
        staticStyle: {
          "display": "inline"
        }
      }, [_c('div', [(_vm.product.product_service == 'P') ? _c('li', {
        staticClass: "box-wrap"
      }, [_vm._v(_vm._s(pt.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (pt.product_item_service_tag)) ? _c('li', {
        staticClass: "box-wrap"
      }, [_vm._v(_vm._s(pt.product_item_service_tag))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', [_c('span', [_vm._v("w(kg):")]), _vm._v(_vm._s(pt.product_item_weight))]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(pt.product_item_price))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Qty:")]), _vm._v(_vm._s(pt.product_item_quantity))]), _vm._v(" "), _c('li', [_c('a', {
        staticClass: "btn btn-xs v-tiny-btn",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('set-edit-product-item', pt)
          }
        }
      }, [_c('i', {
        staticClass: "icon-pencil"
      })])]), _vm._v(" "), (_vm.product.product_items.length > 1) ? _c('li', [_c('a', {
        staticClass: "btn btn-xs v-tiny-btn",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('remove-product-item', pt)
          }
        }
      }, [_c('i', {
        staticClass: "icon-trash"
      })])]) : _vm._e()]), _vm._v(" "), (_vm.editProductItemPanel && (_vm.product_item.product_item_id == pt.product_item_id)) ? _c('div', {
        staticClass: "col-sm-12 contact_form",
        attrs: {
          "id": "editProductItem"
        }
      }, [_c('h6', [_vm._v("Edit Product Item")]), _vm._v(" "), _c('form', [_c('ul', {
        staticClass: "row"
      }, [_c('li', {
        staticClass: "col-md-12"
      }, [_c('label', [_vm._v(" *"), (_vm.product.product_service == 'P') ? _c('span', [_vm._v("Product Item Size")]) : _vm._e(), (_vm.product.product_service == 'S') ? _c('span', [_vm._v("Product Item tYPE")]) : _vm._e(), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_size),
          expression: "product_item.product_item_size"
        }],
        attrs: {
          "type": "text",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_size)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_size = $event.target.value
          }
        }
      })])]), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('li', {
        staticClass: "col-md-12"
      }, [_c('label', [_vm._v(" *Service Tag\r\n                                                "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_service_tag),
          expression: "product_item.product_item_service_tag"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_service_tag)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_service_tag = $event.target.value
          }
        }
      })])]) : _vm._e(), _vm._v(" "), _c('li', {
        staticClass: "col-md-12"
      }, [_c('label', [_vm._v(" *Product Item Price\r\n                                                "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_price),
          expression: "product_item.product_item_price"
        }],
        attrs: {
          "type": "number",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_price)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_price = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('li', {
        staticClass: "col-md-12"
      }, [_c('label', [_vm._v(" *Product Item Weight\r\n                                              "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_weight),
          expression: "product_item.product_item_weight"
        }],
        attrs: {
          "type": "number",
          "step": "any",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_weight)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_weight = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('li', {
        staticClass: "col-md-12"
      }, [_c('label', [_vm._v(" *Product Item Quantity\r\n                                                  "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_quantity),
          expression: "product_item.product_item_quantity"
        }],
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_quantity)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_quantity = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('li', {
        staticClass: "col-md-12"
      }, [(_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e(), _vm._v(" "), _c('button', {
        staticClass: "btn col-md-4",
        staticStyle: {
          "line-height": "1.2",
          "margin-right": "5px"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": _vm.editProductItem
        }
      }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
        staticClass: "btn col-md-4",
        staticStyle: {
          "line-height": "1.2",
          "margin-right": "5px"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_c('i', {
        staticClass: "icon-ban"
      }), _vm._v(" Cancel")])]), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.removeItemPanel && (_vm.product_item.product_item_id == pt.product_item_id)) ? _c('span', {
        staticClass: "pull-left col-sm-12"
      }, [_c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Do you really want to remove this Item?")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs",
        on: {
          "click": function($event) {
            _vm.removeProductItem()
          }
        }
      }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs",
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })])
    })], 2), _vm._v(" "), _c('hr')])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {}, [(_vm.product.product_service == 'P') ? _c('p', [_vm._v("add other variations like colors, sizes etc")]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('p', [_vm._v("add other variations like the Service package, subscriptions and plans etc")]) : _vm._e(), _vm._v(" "), (!_vm.addProductItemPanel) ? _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('add-product-item', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Product Variation")]) : _c('div', [_c('button', {
    staticClass: "btn pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" Cancel")]), _vm._v(" "), _c('div', [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('product-item-form')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('remove-product', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete this Product")]), _vm._v(" "), (_vm.removeProductPanel) ? _c('span', {}, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to remove this Product?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": _vm.removeProduct
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])]), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "specific-detail-cards padding-top-100 padding-bottom-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-xs-12 card product-specific-cards"
  }, [(_vm.edit_mode) ? _c('div', [_c('h6', [_vm._v("ITEM DISCOUNTS")]), _vm._v(" "), _c('div', [(_vm.setDiscount) ? _c('div', [_c('div', {
    staticClass: "contact-form col-md-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form_control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setDiscountsAndCoupons()
      }
    }
  }, [_vm._v("SET")])]), _vm._v(" "), _c('li', {
    staticClass: "form-group col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _vm._m(8)]) : _vm._e(), _vm._v(" "), (_vm.editDiscount) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Edit Discount")]), _vm._v(" "), _c('div', {
    staticClass: "contact-form col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date: " + _vm._s(_vm.discount_coupon.discount_start_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.editDiscountsAndCoupons()
      }
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('li', {
    staticClass: "form-group col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _c('div', [_vm._l((_vm.product_item.product_item_discounts), function(dc) {
    return _c('div', [(dc.discount_status_id == 5) ? _c('div', [(dc.discount_product_item == _vm.product_item.product_item_id) ? _c('p', [_c('b', [_vm._v("Product Item Discount")])]) : _c('p', [_c('b', [_vm._v("General Sellpoint Discount")])]), _vm._v(" "), (dc.discount_product_item != _vm.product_item.product_item_id) ? _c('p', [_c('b', [_vm._v("Type: ")]), _vm._v(_vm._s(dc.discount_category_name))]) : _vm._e(), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), (dc.discount_product_item == _vm.product_item.product_item_id) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-discount', dc)
        }
      }
    }, [_vm._v("\r\n                                  Edit Discount")]), _vm._v("    \r\n                                "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.deactivateDiscountsAndCoupons(dc)
        }
      }
    }, [_vm._v("\r\n                                  Deactivate Discount")])]) : _vm._e(), _vm._v(" "), _c('hr')]) : _c('div', [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("You don't have an active discount")]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "2em"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-discount', '')
        }
      }
    }, [_vm._v("Set New Discount Or Coupon")])])])
  }), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You don't have an active discount")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-discount', '')
      }
    }
  }, [_vm._v("Set New Discount Or Coupon")])])], 2)]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-12 card product-specific-cards"
  }, [_c('div', [_c('h6', [_vm._v("DELIVERY & RETURNS INFORMATION")]), _vm._v(" "), (_vm.edit_mode) ? _c('div', [(_vm.details.edit_product_delivery) ? _c('div', {
    staticClass: "contact-form"
  }, [_c('li', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_delivery_returns),
      expression: "product.product_delivery_returns"
    }],
    domProps: {
      "value": (_vm.product.product_delivery_returns)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_delivery_returns = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setProductDelivery()
      }
    }
  }, [_c('i', {
    staticClass: "icon-check"
  }), _vm._v("submit")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" cancel")])])]) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Set delivery and returns information for this product, Note that this is different from setting delivery places")]), _vm._v(" "), _c('p', [(_vm.product.product_delivery_returns) ? _c('span', [_vm._v(_vm._s(_vm.product.product_delivery_returns))]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "13px"
    },
    attrs: {
      "type": "btn",
      "title": "Edit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('edit-product-delivery', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Set Delivery & Return Information")]) : _vm._e(), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), (!_vm.edit_mode) ? _c('div', {
    staticClass: "tiny-notice",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em",
      "background": "#fcf7f3"
    }
  }, [(_vm.product.product_delivery_returns != ' ') ? _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.product.product_delivery_returns) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Please note that Returns, Shipping and Delivery are handled independently by the seller.\r\n                          Sellpoint only provides a conducive platform for both sellers and buyers, we also recommend reliable shipping \r\n                          partners to make transactions seamless.\r\n                        ")])]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set How Product Shipping Fee would affect Buyers Checkout Ordering")]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_set_shipping_fee_status),
      expression: "product_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "12",
      "value": "12"
    },
    domProps: {
      "checked": _vm._q(_vm.product_set_shipping_fee_status, "12")
    },
    on: {
      "click": function($event) {
        _vm.setProductShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.product_set_shipping_fee_status = "12"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Product Charge is not on each Quantiy of Product Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_set_shipping_fee_status),
      expression: "product_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "13",
      "value": "13"
    },
    domProps: {
      "checked": _vm._q(_vm.product_set_shipping_fee_status, "13")
    },
    on: {
      "click": function($event) {
        _vm.setProductShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.product_set_shipping_fee_status = "13"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Product Charge is on each Quantiy of Product Ordered")])])]), _vm._v(" "), (_vm.set_shipping_fee_status_track && _vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-12 card product-specific-cards"
  }, [_c('div', [_c('h6', [_vm._v("PRODUCT DELIVERY LOCATIONS")]), _vm._v(" "), (_vm.edit_mode) ? _c('div', [_c('div', [_vm._l((_vm.product.product_delivery_options), function(delivery) {
    return _c('li', {
      staticStyle: {
        "display": "none"
      }
    }, [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦" + _vm._s(delivery.business_delivery_option_price) + "\r\n                            "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-delivery-option', delivery)
        }
      }
    }, [_c('i', {
      staticClass: "icon-edit"
    })]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.deleteDeliveryOption(delivery.business_delivery_option_id)
        }
      }
    }, [_c('i', {
      staticClass: "icon-close"
    })]), _vm._v(" "), (_vm.editDeliveryInformation && delivery.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('li', [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.delivery_option.business_delivery_state),
        expression: "delivery_option.business_delivery_state"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.delivery_option.business_delivery_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities(_vm.delivery_option.business_delivery_state, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state.state_id
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2)]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.delivery_option) + "\r\n                                  "), _c('label', [_vm._v("City: "), _c('b', [_vm._v(_vm._s(_vm.delivery_option.business_delivery_option))])]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.delivery_option.city),
        expression: "delivery_option.city"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.setOtherOptions(_vm.delivery_option.city, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "all"
      }
    }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city.city_id
        }
      }, [_vm._v(_vm._s(city.city_name))])
    }), _vm._v(" "), _c('option', {
      attrs: {
        "value": "other"
      }
    }, [_vm._v("Other Areas / Cities ")])], 2)]), _vm._v(" "), (_vm.edit_other_delivery_option) ? _c('li', [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.delivery_option.business_delivery_other_option),
        expression: "delivery_option.business_delivery_other_option"
      }],
      attrs: {
        "type": "text",
        "placeholder": "eg. Abuja"
      },
      domProps: {
        "value": (_vm.delivery_option.business_delivery_other_option)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.delivery_option.business_delivery_other_option = $event.target.value
        }
      }
    }), _c('br')]) : _vm._e(), _vm._v(" "), _c('li', [_c('label', [_vm._v("Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.delivery_option.business_delivery_option_price),
        expression: "delivery_option.business_delivery_option_price"
      }],
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (_vm.delivery_option.business_delivery_option_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.delivery_option.business_delivery_option_price = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('li', [_c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.editDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _vm._e()])
  }), _vm._v(" "), (_vm.product.product_business_delivery_options.length != 0) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have set some general delivery settings")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v("You can set a different delivery fee for this product")]), _c('br'), _vm._v(" "), _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦\r\n                              "), (delivery.business_products_delivery_fees.length > 0) ? _c('span', _vm._l((delivery.business_products_delivery_fees), function(fee, fdex) {
      return _c('span', [((fee.product_delivery_product == _vm.product.product_id)) ? _c('span', [_vm._v(_vm._s(fee.product_delivery_fee) + "\r\n                                  ")]) : _vm._e()])
    })) : _c('span', [_vm._v("\r\n                                " + _vm._s(delivery.business_delivery_option_price) + "\r\n                              ")]), _vm._v(" "), (_vm.setProductDeliveryInformation && delivery.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('li', [_c('label', [_vm._v("Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery.product_delivery_fee),
        expression: "delivery.product_delivery_fee"
      }],
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (delivery.product_delivery_fee)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery.product_delivery_fee = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('li', [(_vm.setProductDeliveryInformation && _vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.setProductDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "font-size": "10px"
      },
      attrs: {
        "type": "btn",
        "title": "Set Product Delivery Fee"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-delivery-option', delivery)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Set Fee")])])
  })], 2) : _c('div', [_c('p', [_vm._v("You have not set your Business Delivery Locations")])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "13px",
      "display": "none"
    },
    attrs: {
      "type": "btn",
      "title": "Edit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('add-delivery-option', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Add Product Delivery Location")]) : _vm._e(), _vm._v(" "), _c('br')], 2), _vm._v(" "), (_vm.addDeliveryInformation) ? _c('div', {
    staticClass: "contact_form col-md-12",
    staticStyle: {
      "padding-left": "0",
      "display": "none"
    }
  }, [_c('h5', [_vm._v("Add a Delivery Location and Price")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('li', [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other Areas / Cities ")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.other_delivery_option) ? _c('li', [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_other_option),
      expression: "delivery_option.delivery_other_option"
    }],
    attrs: {
      "type": "text",
      "placeholder": "eg. Abuja"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_other_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_other_option = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e(), _vm._v(" "), _c('li', [_c('label', [_vm._v("Delivery Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_price),
      expression: "delivery_option.delivery_option_price"
    }],
    attrs: {
      "type": "number",
      "placeholder": "Eg. 1000"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_option_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_option_price = $event.target.value
      }
    }
  }), _c('br')]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn col-sm-4",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": _vm.addDeliveryOption
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn col-sm-4",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.edit_mode) ? _c('div', {
    staticClass: "tiny-notice",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em",
      "background": "#fcf7f3"
    }
  }, [_c('h4', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("View Shipping Cost for different Locations")]), _vm._v(" "), _c('div', [(((_vm.product.product_delivery_options) && (_vm.product.product_delivery_options.length != 0))) ? _c('div', _vm._l((_vm.product.product_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦" + _vm._s(delivery.business_delivery_option_price) + "\r\n                            ")])
  })) : _c('div', _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦" + _vm._s(delivery.business_delivery_option_price) + " \r\n                              ")])
  }))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-12 card product-specific-cards"
  }, [_c('div', {
    staticClass: "inner-info"
  }, [_c('h6', [_vm._v("SHARE THIS PRODUCT")]), _vm._v(" "), _c('ul', {
    staticClass: "social_icons"
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Click the Copy button below to Copy product link, paste the link anywhere you want to share to")]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "linky",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "13px"
    },
    attrs: {
      "title": "Copy Link. Paste and Share Anywhere"
    },
    on: {
      "click": function($event) {
        _vm.copyLink()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  }), _vm._v("Copy Product Link and Share Anywhere\r\n                          ")]), _vm._v(" "), (_vm.copied) ? _c('span', {
    staticStyle: {
      "background": "rgb(240, 227, 157)"
    }
  }, [_vm._v("Copied, Paste anywhere you want to share to")]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row product-details-section",
    attrs: {
      "id": "productDetails"
    }
  }, [_c('div', {
    staticClass: "card item-decribe"
  }, [_c('ul', {
    staticClass: "nav nav-tabs animate fadeInUp"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-descr', '')
      }
    }
  }, [_vm._v("PRODUCT DETAILS")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-reviews', '')
      }
    }
  }, [_vm._v("COMMENTS & REVIEWS")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-information', '')
      }
    }
  }, [_vm._v("MORE INFORMATION")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content animate fadeInUp details-box"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.product_details_reviews) ? _c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [(_vm.product.product_reviews) ? _c('h6', [_vm._v(_vm._s(_vm.product.product_reviews.length) + " COMMENTS AND REVIEWS")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.product.product_reviews), function(review) {
    return _c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "media-left"
    }, [_c('div', {
      staticClass: "avatar"
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('img', {
      staticClass: "media-object",
      attrs: {
        "src": _vm.img_user_url + review.product_reviewed_by_image,
        "alt": ""
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h6', [_vm._v(_vm._s(review.product_reviewed_by)), _c('span', {
      staticClass: "pull-right"
    })]), _vm._v(" "), _c('p', {
      staticClass: "font-playfair"
    }, [_vm._v(_vm._s(review.product_review))]), _vm._v(" "), _c('h6', [_c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(review.product_review_date))])])])])
  }), _vm._v(" "), (!_vm.edit_mode) ? _c('div', [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("ADD COMMENT/REVIEW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You must have used this product to wrie a review.")]), _vm._v(" "), _c('form', [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *YOUR REVIEW\r\n                                    "), _c('span', {
    staticClass: "pull-right"
  }, [_c('label', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user_type),
      expression: "user_type"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "bo",
      "id": "bo"
    },
    domProps: {
      "checked": _vm._q(_vm.user_type, "bo")
    },
    on: {
      "__c": function($event) {
        _vm.user_type = "bo"
      }
    }
  }), _vm._v("Business Owner\r\n                                        ")]), _vm._v(" "), (!_vm.loggedIn) ? _c('label', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user_type),
      expression: "user_type"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "buyer",
      "id": "buyer"
    },
    domProps: {
      "checked": _vm._q(_vm.user_type, "buyer")
    },
    on: {
      "__c": function($event) {
        _vm.user_type = "buyer"
      }
    }
  }), _vm._v("Buyer\r\n                                        ")]) : _vm._e()]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reviews.review),
      expression: "reviews.review"
    }],
    domProps: {
      "value": (_vm.reviews.review)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reviews.review = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('li', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-dark btn-small pull-right no-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addProductReview
    }
  }, [_vm._v("POST")])])])])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.product_details_information) ? _c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_vm._l((_vm.product.product_information), function(info) {
    return _c('div', {}, [(info.product_info_type == 'image') ? _c('div', [_c('p', [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": _vm.img_product_url + info.product_info_detail,
        "alt": ""
      }
    })])]) : _vm._e(), _vm._v(" "), (info.product_info_type == 'text') ? _c('div', [_c('p', [_vm._v(_vm._s(info.product_info_detail))]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('br'), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.information.product_info_detail),
      expression: "information.product_info_detail"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter new product information"
    },
    domProps: {
      "value": (_vm.information.product_info_detail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.information.product_info_detail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": _vm.addProductInformation
    }
  }, [_vm._v("Add to Product Information")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Add an Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'product_information', _vm.product.product_id)
      }
    }
  })])])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.product_details_descr) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), _c('h6', [_vm._v("MORE DETAILS")]), _vm._v(" "), _c('ul', _vm._l((_vm.product.product_details), function(details) {
    return _c('li', [(_vm.edit_mode) ? _c('div', [(details.edit_product_detail) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (details.product_detail),
        expression: "details.product_detail"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (details.product_detail)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          details.product_detail = $event.target.value
        }
      }
    }), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": _vm.editProductDetail
      }
    }, [_c('i', {
      staticClass: "icon-check"
    })])]) : _c('p', [_vm._v(_vm._s(details.product_detail) + "\r\n                                "), (_vm.edit_mode) ? _c('span', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-product-detail', details)
        }
      }
    }, [_c('i', {
      staticClass: "icon-edit"
    })]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.deleteProductDetail(details)
        }
      }
    }, [_c('i', {
      staticClass: "icon-trash"
    })])]) : _vm._e()])]) : _c('p', [_vm._v(_vm._s(details.product_detail))])])
  })), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('br'), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details.new_product_detail),
      expression: "details.new_product_detail"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter new product detail"
    },
    domProps: {
      "value": (_vm.details.new_product_detail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details.new_product_detail = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": _vm.addProductDetail
    }
  }, [_vm._v("Add to Details")])])]) : _vm._e()]) : _vm._e()])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "light-gray-bg padding-top-50 padding-bottom-150"
  }, [_c('div', {}, [_c('div', {
    staticClass: "card"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "papular-block"
  }, _vm._l((_vm.other_products), function(o_product) {
    return _c('div', {
      staticClass: "shop-detail prd-market-block"
    }, [(_vm.product.product_id != o_product.product_id) ? _c('div', _vm._l((o_product.product_items), function(o_product_item, index2) {
      return _c('div', {
        staticClass: "row"
      }, [(index2 == 0) ? _c('div', {
        staticClass: "col-md-8 col-md-offset-2"
      }, [_c('a', {
        attrs: {
          "href": o_product.product_url_name
        }
      }, [_c('h4', [_c('a', {
        attrs: {
          "href": o_product.product_url_name
        }
      }, [_vm._v(_vm._s(o_product.product_name))])]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(o_product_item.product_item_price))]), _vm._v(" "), _c('div', {
        staticClass: "item-img"
      }, [_c('img', {
        staticClass: "sp-prd-img img-1",
        attrs: {
          "src": _vm.img_product_url + o_product_item.product_item_image,
          "alt": ""
        }
      })]), _vm._v(" "), _vm._m(11, true), _vm._v(" "), _c('ul', {
        staticClass: "item-owner"
      }, [_c('li', [_vm._v("Category:"), _c('span', [_vm._v(" " + _vm._s(o_product.product_category_name))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(o_product.product_description))])])]) : _vm._e()])
    })) : _vm._e()])
  }))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottombar",
    staticStyle: {
      "margin-top": "15em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#home"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#news"
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#contact"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Price: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Discount Price: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Weight: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Quantity:  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left-2 col-xs-2"
  }, [_c('h6', [_vm._v("DELIVERY & RETURNS INFORMATION")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left-2 col-md-2 col-xs-12"
  }, [_c('h6', [_vm._v("PRODUCT DELIVERY LOCATIONS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-form col-md-12"
  }, [_c('p', {
    staticStyle: {
      "color": "#363535"
    }
  }, [_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                              If you want to end an existing discount click on \"Stop Discount\" button near the\r\n                              button.\r\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "stars"
  }, [_c('span', [_vm._v("YOUR RATING")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading text-center"
  }, [_c('h4', [_vm._v("I ALSO HAVE THESE")]), _vm._v(" "), _c('span', [_vm._v("Check out other products found in my sellpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "on-sale"
  }, [_vm._v(" 10% "), _c('span', [_vm._v("OFF")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b29a9a06"}!./src/pages/Sellpoint/Product/template.html
// module id = 270
// module chunks = 0